import { NotificationType } from '@creator/sdk/modules/notification/notification.model';

export function getNotificationSettingsTypes(): NotificationType[] {
    return ['newCommentOnPost', 'newReplyOnComment', 'taggedOnComment', 'newUpvoteOnPost', 'outUpvoted', 'newReactionPost', 'newReactionComment', 'newReactionReply', 'tipOnComment', 'tipOnPost', 'newDirectMessage'];
}
